export const create = {
  createSuccessfully: 'Create new language successfully!',
}
